<template>
  <div class="content">
    <BlockUI
      v-if="blockScreen"
      :message="blockScreenData.msg"
      :url="blockScreenData.url"
    />

    <v-card>
      <v-card-title>
        <TitleWithButton
          title="Cupons"
          buttonText="Novo cupom"
          :buttonFunction="openAddCoupon"
        />
      </v-card-title>

      <v-card-subtitle>
        <v-flex class="mt-2">
          <v-row justify="space-between">
            <v-flex xs12 md4 sm6>
              <v-col align="start">
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Procurar"
                  single-line
                  hide-details
                />
              </v-col>
            </v-flex>
          </v-row>
        </v-flex>
      </v-card-subtitle>

      <v-divider />

      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="coupons"
          :search="search"
          class="elevation-1 mt-2"
          :footer-props="{
            'items-per-page-text': 'Linhas por página:',
          }"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td class>
                <ActionButton
                  message="Histórico do cupom"
                  icon="mdi-open-in-new"
                  @onclick="showCouponDetails(item)"
                />
              </td>
              <td class>{{ item.name }}</td>
              <td class>{{ item.value }}</td>
              <td class>{{ item.free_km_max }}</td>
              <td class>{{ item.percentual_desconto }}</td>
              <td class>{{ item.limite_usuario }}</td>
              <td class>{{ item.total_aplicado }}</td>
              <td class>{{ item.exclusive_type | whichType }}</td>
              <td class>{{ item.expiration_date | formatDate }}</td>
              <td class>
                <ActionButton
                  message="Editar cupom"
                  icon="edit"
                  @onclick="editItem(item)"
                />
                <ActionButton
                  message="Excluir cupom"
                  icon="delete"
                  color="error"
                  @onclick="deleteItem(item.id)"
                />
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <template>
      <v-layout row justify-center>
        <v-dialog v-model="add_coupon" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="headline">
                {{ this.coupom.id ? 'Editar cupom' : 'Novo cupom' }}
              </span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex sm4>
                    <v-text-field
                      label="Nome"
                      :rules="[
                        (v) => !!v || 'Campo obrigatório!',
                        (v) => validCoupon(v) || 'nome inválido',
                      ]"
                      v-model="coupom.name"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm4>
                    <v-text-field
                      :disabled="coupom.exclusive_type != 'non_exclusive'"
                      label="Minutos bônus"
                      :rules="[
                        (v) => !!v || 'Campo obrigatório!',
                        (v) => v >= 0 || 'Valor inválido!',
                      ]"
                      v-model="coupom.value"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm4>
                    <v-text-field
                      label="Kms disponíveis"
                      v-model="coupom.free_km_max"
                      :rules="[
                        (v) => !!v || 'Campo obrigatório!',
                        (v) => v >= 0 || 'Valor inválido!',
                      ]"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm4>
                    <v-text-field
                      label="Desconto (%)"
                      :rules="[
                        (v) => !!v || 'Campo obrigatório!',
                        (v) => v >= 0 || 'Valor inválido!',
                      ]"
                      v-model="coupom.percentual_desconto"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm4>
                    <v-text-field
                      label="Limite de usuários"
                      v-model="coupom.limite_usuario"
                      :rules="[
                        (v) => !!v || 'Campo obrigatório!',
                        (v) => v >= 0 || 'Valor inválido!',
                      ]"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm4 v-if="this.coupom.id">
                    <v-text-field
                      label="Total Utilizado"
                      v-model="coupom.total_aplicado"
                      disabled
                      required
                    ></v-text-field>
                  </v-flex>

                  <v-flex md12>
                    <v-menu
                      v-model="menu2"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      required
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="coupom.expiration_date"
                          label="Data de expiração"
                          prepend-icon="event"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="coupom.expiration_date"
                        :min="dateNow()"
                        @input="menu2 = false"
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-flex>

                  <v-flex md4>
                    <v-checkbox 
                      label="Limitar checkin"
                      v-model="limitCheckin"
                      @click="coupom.useful_after = null, coupom.useful_until = null"
                    />
                  </v-flex>
                  <v-flex md4>
                    <v-text-field 
                      label="De"
                      v-mask="'##:##:##'"
                      placeholder="HH:MM:SS"
                      v-if="limitCheckin"
                      v-model="coupom.useful_after"
                      @click="activeTime = true"
                    />
                    <v-dialog 
                      v-model="activeTime"
                      max-width="300px"
                    >
                      <v-time-picker
                        format="24hr"
                        v-model="coupom.useful_after"
                      ></v-time-picker>
                    </v-dialog>
                  </v-flex>
                  <v-flex md4>
                    <v-text-field 
                      label="Até"
                      v-mask="'##:##:##'"
                      placeholder="HH:MM:SS"
                      v-if="limitCheckin"
                      v-model="coupom.useful_until"
                      @click="activeTime2 = true"
                    />
                    <v-dialog 
                      v-model="activeTime2"
                      max-width="300px"  
                    >
                      <v-time-picker
                        format="24hr"
                        v-model="coupom.useful_until"
                      ></v-time-picker>
                    </v-dialog>
                  </v-flex>


                  <v-flex sm6>
                    <v-radio-group
                      mandatory
                      row
                      @change="checkType()"
                      hide-details
                      v-model="coupom.exclusive_type"
                      value="2"
                      class="mt-2 mx-3"
                    >
                      <v-radio
                        label="Não exclusivo"
                        value="non_exclusive"
                      ></v-radio>
                      <v-radio
                        label="Pacote de Horas"
                        value="wallet_hours"
                      ></v-radio>
                      <v-radio
                        label="Assinatura(Recorrencia)"
                        value="recurrent"
                      ></v-radio>
                    </v-radio-group>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="cleanFields"
                >Cancelar</v-btn
              >
              <v-btn
                :disabled="
                  this.coupom.id
                    ? false
                    : !coupom.name ||
                      !coupom.free_km_max ||
                      !coupom.percentual_desconto ||
                      !coupom.limite_usuario ||
                      !coupom.expiration_date
                "
                color="blue darken-1"
                text
                @click="save()"
              >
                Salvar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </template>

    <template>
      <v-layout row justify-center>
        <v-dialog v-model="showCouponDetailsDialog" max-width="1000px">
          <v-card>
            <v-card-title>
              <span class="headline"
                >Utilizações do cupom '{{ coupom.name }}'</span
              >
            </v-card-title>
            <v-card-text>
              <v-data-table
                :headers="couponDetailsHeaders"
                :items="couponDetailsItems"
                :search="searchCouponDetails"
                :footer-props="{
                  'items-per-page-text': 'Linhas por página:',
                  'items-per-page-options': [15, 30, 50, 100],
                }"
                no-data-text="Este cupom ainda não foi utilizado"
                class="elevation-1"
              >
                <template v-slot:top>
                  <v-text-field
                    v-model="searchCouponDetails"
                    label="Procurar"
                    class="mx-4"
                  ></v-text-field>
                </template>
              </v-data-table>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="
                  showCouponDetailsDialog = false;
                  searchCouponDetails = '';
                "
              >
                Fechar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </template>
  </div>
</template>

<script>
import moment from 'moment';
import { blockScreenUi } from '../../helpers/BlockScreenUi';
import Multiselect from 'vue-multiselect';
import CouponController from '../../controllers/CouponController';
import VehicleRequestController from '../../controllers/VehicleRequestController';
import ActionButton from '../shared/ActionButtonsTemplate';
import TitleWithButton from '../../UIComponents/titleWithButton.vue';

export default {
  components: {
    ActionButton,
    TitleWithButton,
    Multiselect,
  },
  created() {
    this.getCoupon();

    this.checkType();
  },

  data() {
    return {
      couponController: new CouponController(this.$resource),
      VehicleRequestController: new VehicleRequestController(this.$resource),
      blockScreenData: blockScreenUi.blockScreenData,
      blockScreen: false,
      search: '',
      searchCouponDetails: '',
      limitCheckin: false,
      activeTime: false,
      activeTime2: false,
      json_fields: {
        Nome: 'name',
        Value: 'value',
      },
      headers: [
        { text: '', value: 'expand' },
        { text: 'Nome', value: 'name' },
        { text: 'Minutos bônus', value: 'value' },
        { text: 'Km Disponíveis', value: 'free_km_max' },
        { text: 'Desconto(%)', value: 'percentual_desconto' },
        { text: 'Limite de Usuários', value: 'limite_usuario' },
        { text: 'Total Utilizado', value: 'total_aplicado' },
        { text: 'Tipo exclusivo', value: 'exclusive_type' },
        { text: 'Data de expiração', value: 'expiration_date' },
        { text: 'Ações', value: 'action', sortable: false },
      ],
      couponDetailsHeaders: [
        { text: 'Usuário Nome', value: 'name' },
        { text: 'Usuário CPF', value: 'cpf' },
        { text: 'Veículo Modelo', value: 'model' },
        { text: 'Veículo Placa', value: 'plate' },
        { text: 'Check-in', value: 'checkin' },
        { text: 'Check-out', value: 'checkout' },
        { text: 'Reserva Status', value: 'status' },
      ],
      coupom: {},
      coupons: [],
      couponDetailsItems: [],
      add_coupon: false,
      showCouponDetailsDialog: false,
      showCoupon: null,
      free_km: 0,
      menu2: false,
    };
  },
  methods: {
    checkType() {
      this.coupom.value =
        this.coupom.exclusive_type == 'non_exclusive' ? this.coupom.value : 0;
    },
    async showCouponDetails(item) {
      this.couponDetailsItems = [];
      this.coupom = item;

      const vehicleRequests = await this.VehicleRequestController.getByCouponId(
        this.coupom.id
      );

      vehicleRequests.forEach((request) => {
        this.couponDetailsItems.push({
          name: request.user.name,
          cpf: request.user.cpf,
          model: request.vehicle.vehicle_model.model,
          plate: request.vehicle.plate,
          status: request.step.title,
          checkin: moment(request.begin_date).format('DD[/]MM[/]YYYY HH:mm'),
          checkout: moment(request.end_date).format('DD[/]MM[/]YYYY HH:mm'),
        });
      });

      this.showCouponDetailsDialog = true;
    },

    async getCoupon() {
      this.coupons = await this.couponController.get();
      await this.coupons.forEach((cupon) => {
        cupon.free_km_max = cupon.free_meters_max / 1000;
      });
    },
    validCoupon(name) {
      if (this.coupons.find((coupon) => coupon.name === name)) {
        return true;
      } else if (!this.coupom.id && !'') {
        return true;
      } else {
        return false;
      }
    },
    dateNow() {
      const begin = new Date();
      begin.setHours(begin.getHours());
      return moment(begin).toISOString(true);
    },
    cleanFields() {
      (this.add_coupon = false), 
      (this.coupom = {}), 
      (this.useful_until = null), 
      (this.useful_after = null), 
      (this.limitCheckin = false)
    },
    deleteItem(id) {
      this.couponController
        .delete(id)
        .then((res) => {
          this.getCoupon();
          this.$awn.success('Cupom deletado com sucesso.');
        })
        .catch((e) => {
          this.$awn.alert('Erro ao deletar cupom.');
        });
    },
    save() {
      if (this.coupom.id) this.update();
      else this.create();
    },
    update() {
      this.coupom.free_meters_max = Number(this.coupom.free_km_max) * 1000;
      this.coupom.free_km = this.coupom.free_km_max;
      if (this.limitCheckin == true && (this.coupom.useful_after == null || this.coupom.useful_until == null)) {
        this.$awn.alert('Preencha os dois campos de Limitar Checkin.');
        throw('Erro ao atualizar voucher');
      };
      this.couponController
        .update(this.coupom)
        .then((res) => {
          this.getCoupon();
          this.$awn.success('Cupom atualizado com sucesso.');
        })
        .catch((e) => {
          this.$awn.alert('Erro ao atualizar cupom.');
        })
        .finally(() => {
          this.coupom = {};
          this.add_coupon = false;
          this.useful_until = null; 
          this.useful_after = null;
          this.limitCheckin = false;
        });
    },
    create() {
      this.coupom.free_meters_max = this.coupom.free_km_max * 1000;
      this.coupom.name = this.coupom.name.toUpperCase();
      if (this.limitCheckin == true && (this.coupom.useful_after == null || this.coupom.useful_until == null)) {
        this.$awn.alert('Preencha os dois campos de Limitar Checkin.');
        throw('Erro ao atualizar voucher');
      };
      this.couponController
        .create(this.coupom)
        .then((res) => {
          this.getCoupon();
          this.$awn.success('Cupom cadastrado com sucesso.');
        })
        .catch((e) => {
          this.$awn.alert(e.body.message);
        })
        .finally(() => {
          this.coupom = {};
          this.add_coupon = false;
          this.useful_until = null;
          this.useful_after = null;
          this.limitCheckin = false;
        });
    },
    editItem(item) {
      item.free_km = Number.parseInt(item.free_meters_max);

      this.coupom = Object.assign({}, item);
      this.add_coupon = true;

      this.coupom.useful_after || this.coupom.useful_until  ? this.limitCheckin = true : this.limitCheckin = false
    },

    openAddCoupon() {
      this.add_coupon = true;
    },
  },
  filters: {
    formatDate(dateString) {
      if (dateString) {
        return moment(dateString).format('DD[/]MM[/]YYYY');
      }
    },
    whichType(type) {
      if (type == 'non_exclusive') {
        return 'Não exclusivo';
      } else if (type == 'wallet_hours') {
        return 'Pacote de Horas';
      } else {
        return 'Assinatura';
      }
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
.radios {
  margin: 5px;
}
.radios input {
  margin-right: 3px;
}
.radios label {
  margin-right: 15px;
}
.table-custom-vue {
  margin: 20px;
}
.table-custom-vue td:last-child {
  display: flex;
  justify-content: center;
}
.table-custom-vue thead tr > th,
.table-custom-vue tbody td {
  text-align: center !important;
}

.import-driver-button,
.new-driver-button {
  border: none;
  &:hover {
    background: var(--primary-color-hover);
  }
}
.card-header .filter-header {
  background: var(--secondary-color) !important;
}

.import-driver-button,
.new-driver-button {
  border: none;
  &:hover {
    color: white;
    background: var(--primary-color-hover);
  }
}
</style>
